<ng-container *transloco="let _t">

<ul>
    <li *ngFor="let tool of gd.toollist">
      <span *ngIf="conditionSatisfied(tool)">
        <button mat-raised-button *ngIf="tool.Type=='Button'"
            [color]="tool.Color"
            (click)="send(tool)">
            <mat-icon *ngIf="tool.Icon!=''">{{tool.Icon}}</mat-icon>
            {{ _t(tool.Label) }}
        </button>
        <button mat-mini-fab *ngIf="tool.Type=='Icon'"
            [color]="tool.Color"
            (click)="send(tool)"
            [title]="tool.Label">
            <mat-icon *ngIf="tool.Icon!=''">{{tool.Icon}}</mat-icon>
        </button>
        <a mat-raised-button *ngIf="tool.Type=='Link'"
            [color]="tool.Color"
            [routerLink]="tool.Link">
            <mat-icon *ngIf="tool.Icon!=''">{{tool.Icon}}</mat-icon>
            {{ _t(tool.Label) }}
        </a>
        <button *ngIf="tool.Type=='Text'"
            [color]="tool.Color" style="color:#000000; font-weight: bold;"
            disabled>
            {{ _t(tool.Label) }} : {{ tool.Value }}
        </button>
      </span>

    </li>
</ul>

</ng-container>
